import { useState } from 'react';

export default function ServicesGrid() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const services = [
    {
      icon: 'ri-customer-service-2-line',
      title: 'System Support',
      description: 'Round-the-clock technical assistance ensuring your systems run smoothly with minimal downtime and maximum efficiency.',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Technology Advisory',
      description: 'Strategic guidance on technology adoption, system integration, and digital innovation to enhance business capabilities.',
    },
    {
      icon: 'ri-rocket-2-line',
      title: 'Digital Transformation',
      description: 'End-to-end digital transformation services to modernize operations and accelerate business growth in the digital age.',
    },
    {
      icon: 'ri-server-line',
      title: 'Infrastructure Management',
      description: 'Comprehensive management of IT infrastructure including servers, networks, and data centers for optimal performance.',
    },
    {
      icon: 'ri-cloud-line',
      title: 'Cloud Solutions',
      description: 'Scalable cloud migration, deployment, and management services leveraging AWS, Azure, and Google Cloud platforms.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Cybersecurity',
      description: 'Advanced security solutions protecting your digital assets from threats with proactive monitoring and incident response.',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our IT Service Offerings
          </h2>
          <p className="text-lg text-gray-600">
            Comprehensive technology solutions designed to drive your business forward
          </p>
        </div>

        <div className="grid grid-cols-3 gap-8">
          {services.map((service, index) => {
            const isHovered = hoveredCard === index;
            return (
              <div
                key={index}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
                className={`relative p-8 rounded-2xl transition-all duration-300 cursor-pointer border-2 overflow-hidden ${
                  isHovered
                    ? 'bg-gradient-to-br from-teal-500 to-teal-600 border-teal-500 -translate-y-2 shadow-2xl shadow-teal-200'
                    : 'bg-white border-gray-200 hover:border-teal-200 hover:shadow-lg'
                }`}
              >
                {/* 背景光晕 */}
                <div
                  className={`absolute inset-0 rounded-2xl transition-opacity duration-300 ${isHovered ? 'opacity-100' : 'opacity-0'}`}
                  style={{ background: 'radial-gradient(circle at 80% 15%, rgba(255,255,255,0.18) 0%, transparent 60%)' }}
                />

                {/* 图标 */}
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center mb-6 transition-all duration-300 ${
                  isHovered ? 'bg-white/20 scale-110' : 'bg-teal-50 scale-100'
                }`}>
                  <i className={`${service.icon} text-3xl transition-colors duration-300 ${
                    isHovered ? 'text-white' : 'text-teal-600'
                  }`}></i>
                </div>

                <h3 className={`text-2xl font-semibold mb-4 leading-tight transition-colors duration-300 ${
                  isHovered ? 'text-white' : 'text-gray-900'
                }`}>
                  {service.title}
                </h3>

                <p className={`text-base leading-relaxed mb-6 transition-colors duration-300 ${
                  isHovered ? 'text-white/90' : 'text-gray-600'
                }`}>
                  {service.description}
                </p>

                {/* Learn More 箭头滑入 */}
                <div className={`inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap transition-all duration-300 ${
                  isHovered ? 'text-white opacity-100 translate-x-0' : 'text-teal-500 opacity-80 -translate-x-1'
                }`}>
                  Learn More
                  <i className={`ri-arrow-right-line text-lg transition-transform duration-300 ${isHovered ? 'translate-x-1' : ''}`}></i>
                </div>

                {/* 底部装饰线 */}
                <div className={`absolute bottom-0 left-0 h-0.5 bg-white/40 transition-all duration-500 ${isHovered ? 'w-full' : 'w-0'}`} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
